import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/style.css';

const NewsCard = ({ imageUrl, category, date, title, description, detailsLink }) => {
    // Assuming detailsLink is something like '/news/some-news-slug'
    const slug = detailsLink.split('/').pop();

    return (
        <div className="card mb-3 me-md-3 border-0 shadow-sm rounded-0">
            <div className="row g-0 flex-column flex-md-row">
                <div className="col-md-4 col-12">
                    <img src={imageUrl} className="img-fluid rounded-0" alt="" style={{ height: '100%', objectFit: 'cover' }} />
                </div>
                <div className="col-md-8 col-12 d-flex flex-column p-3 justify-content-between">
                    <div className="d-flex align-items-center">
                        <div className="bg-info-subtle rounded px-2 py-1">
                            <div className="text-info fw-normal small">{category}</div>
                        </div>
                        <div className="d-flex align-items-center px-2">
                            <div className="text-secondary small">{date}</div>
                        </div>
                    </div>
                    <div className="d-flex flex-column">
                        <h6 className="card-text fw-medium" style={{ fontSize: '20px' }}>
                            {title}
                        </h6>
                        <p className="card-text text-secondary small truncated-paragraph">{description}</p>
                    </div>
                    <Link to={`/news/${slug}`} className="bg-primary px-3 py-2 round-0 text-white text-decoration-none round-0 fw-normal small w-100">Read More</Link>
                </div>
            </div>
        </div>
    );
};

export default NewsCard;